import { ADD_ACTIVITY_FOLLOW_UP, ADD_ACTIVITY_FOLLOW_UP_FAIL, ADD_ACTIVITY_FOLLOW_UP_SUCCESS, ADD_ACTIVITY_PROJECT_FOLLOW_UP, ADD_ACTIVITY_PROJECT_FOLLOW_UP_FAIL, ADD_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS, ADD_CONTACT_ACTIVITY_FOLLOW_UP, ADD_CONTACT_ACTIVITY_FOLLOW_UP_FAIL, ADD_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS, ADD_PROJECT_LEAD_CALLLOG, ADD_PROJECT_LEAD_CALLLOG_FAIL, ADD_PROJECT_LEAD_CALLLOG_SUCCESS, ADD_PROJECT_LEAD_EMAILLOG, ADD_PROJECT_LEAD_EMAILLOG_FAIL, ADD_PROJECT_LEAD_EMAILLOG_SUCCESS, ADD_PROJECT_LEAD_FOLLOW, ADD_PROJECT_LEAD_FOLLOW_FAIL, ADD_PROJECT_LEAD_FOLLOW_SUCCESS, ADD_PROJECT_LEAD_NOTE, ADD_PROJECT_LEAD_NOTE_FAIL, ADD_PROJECT_LEAD_NOTE_SUCCESS, GET_ACTIVITY_FOLLOW_UP, GET_ACTIVITY_FOLLOW_UP_FAIL, GET_ACTIVITY_FOLLOW_UP_SUCCESS, GET_ACTIVITY_PROJECT_FOLLOW_UP, GET_ACTIVITY_PROJECT_FOLLOW_UP_FAIL, GET_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS, GET_CONTACT_ACTIVITY_FOLLOW_UP, GET_CONTACT_ACTIVITY_FOLLOW_UP_FAIL, GET_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS, GET_PROJECT_LEAD_ALL_ACT, GET_PROJECT_LEAD_ALL_ACT_FAIL, GET_PROJECT_LEAD_ALL_ACT_SUCCESS, GET_PROJECT_LEAD_CALLLOG, GET_PROJECT_LEAD_CALLLOG_FAIL, GET_PROJECT_LEAD_CALLLOG_SUCCESS, GET_PROJECT_LEAD_EMAILLOG, GET_PROJECT_LEAD_EMAILLOG_FAIL, GET_PROJECT_LEAD_EMAILLOG_SUCCESS, GET_PROJECT_LEAD_FOLLOW, GET_PROJECT_LEAD_FOLLOW_FAIL, GET_PROJECT_LEAD_FOLLOW_SUCCESS, GET_PROJECT_LEAD_NOTE, GET_PROJECT_LEAD_NOTE_FAIL, GET_PROJECT_LEAD_NOTE_SUCCESS } from "./actionTypes"

export const getProjectLeadAct = ( leadId,  projectGuid) => (
  {
    type: GET_PROJECT_LEAD_ALL_ACT,
    payload: { leadId, projectGuid },
  })

export const getProjectLeadActSuccess = activities => ({
  type: GET_PROJECT_LEAD_ALL_ACT_SUCCESS,
  payload: activities,
})

export const getProjectLeadActFail = error => ({
  type: GET_PROJECT_LEAD_ALL_ACT_FAIL,
  payload: error,
})

export const addProjectleadFollowUp = (followups) => {
  return {
    type: ADD_PROJECT_LEAD_FOLLOW,
    payload: {followups},
  }
}

export const addProjectleadFollowUpSuccess = followups => ({
  type: ADD_PROJECT_LEAD_FOLLOW_SUCCESS,
  payload: followups,
})

export const addProjectleadFollowUpFail = error => ({
  type: ADD_PROJECT_LEAD_FOLLOW_FAIL,
  payload: error,
})


export const getProjectLeadFollowUp = (leadId, projectGuid) => (
  {
    type: GET_PROJECT_LEAD_FOLLOW,
    payload: { leadId, projectGuid },
  })

export const getProjectLeadFollowUpSuccess = followups => ({
  type: GET_PROJECT_LEAD_FOLLOW_SUCCESS,
  payload: followups,
})

export const getProjectLeadFollowUpFail = error => ({
  type: GET_PROJECT_LEAD_FOLLOW_FAIL,
  payload: error,
})

export const addProjectLeadNote = (notes) => {
  return {
    type: ADD_PROJECT_LEAD_NOTE,
    payload: {notes},
  }
}

export const addProjectLeadNoteSuccess = notes => ({
  type: ADD_PROJECT_LEAD_NOTE_SUCCESS,
  payload: notes,
})

export const addProjectLeadNoteFail = error => ({
  type: ADD_PROJECT_LEAD_NOTE_FAIL,
  payload: error,
})


export const getProjectLeadNote = (leadId, projectGuid) => (
  {
    type: GET_PROJECT_LEAD_NOTE,
    payload: { leadId, projectGuid },
  })

export const getProjectLeadNoteSuccess = notes => ({
  type: GET_PROJECT_LEAD_NOTE_SUCCESS,
  payload: notes,
})

export const getProjectLeadNoteFail = error => ({
  type: GET_PROJECT_LEAD_NOTE_FAIL,
  payload: error,
})

export const addProjectLeadCallLog = (calllogs) => {
  return {
    type: ADD_PROJECT_LEAD_CALLLOG,
    payload: {calllogs},
  }
}


export const addProjectLeadCallLogSuccess = calllogs => ({
  type: ADD_PROJECT_LEAD_CALLLOG_SUCCESS,
  payload: calllogs,
})

export const addProjectLeadCallLogFail = error => ({
  type: ADD_PROJECT_LEAD_CALLLOG_FAIL,
  payload: error,
})


export const getProjectLeadCallLog = (leadId, projectGuid) => (
  {
    type: GET_PROJECT_LEAD_CALLLOG,
    payload: { leadId, projectGuid },
  })

export const getProjectLeadCallLogSuccess = calllogs => ({
  type: GET_PROJECT_LEAD_CALLLOG_SUCCESS,
  payload: calllogs,
})

export const getProjectLeadCallLogFail = error => ({
  type: GET_PROJECT_LEAD_CALLLOG_FAIL,
  payload: error,
})


export const addProjectLeadEmailLog = (emaillogs) => {
  return {
    type: ADD_PROJECT_LEAD_EMAILLOG,
    payload: {emaillogs},
  }
}


export const addProjectLeadEmailLogSuccess = emaillogs => ({
  type: ADD_PROJECT_LEAD_EMAILLOG_SUCCESS,
  payload: emaillogs,
})

export const addProjectLeadEmailLogFail = error => ({
  type: ADD_PROJECT_LEAD_EMAILLOG_FAIL,
  payload: error,
})


export const getProjectLeadEmailLog = (leadId, projectGuid) => (
  {
    type: GET_PROJECT_LEAD_EMAILLOG,
    payload: { leadId, projectGuid },
  })

export const getProjectLeadEmailLogSuccess = emaillogs => ({
  type: GET_PROJECT_LEAD_EMAILLOG_SUCCESS,
  payload: emaillogs,
})

export const getProjectLeadEmailLogFail = error => ({
  type: GET_PROJECT_LEAD_EMAILLOG_FAIL,
  payload: error,
})



export const addActivityFollowUp = (follow) => {
  return {
    type: ADD_ACTIVITY_FOLLOW_UP,
    payload: {follow},
  }
}


export const addActivityFollowUpSuccess = follows => ({
  type: ADD_ACTIVITY_FOLLOW_UP_SUCCESS,
  payload: follows,
})

export const addActivityFollowUpFail = error => ({
  type: ADD_ACTIVITY_FOLLOW_UP_FAIL,
  payload: error,
})


export const getActivityFollowUp = (leadId) => {
  return {
    type: GET_ACTIVITY_FOLLOW_UP,
    payload:{leadId},
  }
}


export const getActivityFollowUpSuccess = leadFollows => ({
  type: GET_ACTIVITY_FOLLOW_UP_SUCCESS,
  payload: leadFollows,
})

export const getActivityFollowUpFail = error => ({
  type: GET_ACTIVITY_FOLLOW_UP_FAIL,
  payload: error,
})



export const addActivityProjectFollowUp = (follow) => {
  return {
    type: ADD_ACTIVITY_PROJECT_FOLLOW_UP,
    payload: {follow},
  }
}


export const addActivityProjectFollowUpSuccess = follows => ({
  type: ADD_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS,
  payload: follows,
})

export const addActivityProjectFollowUpFail = error => ({
  type: ADD_ACTIVITY_PROJECT_FOLLOW_UP_FAIL,
  payload: error,
})


export const getActivityProjectFollowUp = (leadId, projectGuid) => {

  return {
    type: GET_ACTIVITY_PROJECT_FOLLOW_UP,
    payload:{leadId, projectGuid},
  }
}


export const getActivityProjectFollowUpSuccess = leadFollows => ({
  type: GET_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS,
  payload: leadFollows,
})

export const getActivityProjectFollowUpFail = error => ({
  type: GET_ACTIVITY_PROJECT_FOLLOW_UP_FAIL,
  payload: error,
})

export const addContactActivityFollowUp = (follow) => {
  return {
    type: ADD_CONTACT_ACTIVITY_FOLLOW_UP,
    payload: {follow},
  }
}


export const addContactActivityFollowUpSuccess = follows => ({
  type: ADD_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS,
  payload: follows,
})

export const addContactActivityFollowUpFail = error => ({
  type: ADD_CONTACT_ACTIVITY_FOLLOW_UP_FAIL,
  payload: error,
})


export const getContactActivityFollowUp = (leadId) => {
  return {
    type: GET_CONTACT_ACTIVITY_FOLLOW_UP,
    payload:{leadId},
  }
}


export const getContactActivityFollowUpSuccess = leadFollows => ({
  type: GET_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS,
  payload: leadFollows,
})

export const getContactActivityFollowUpFail = error => ({
  type: GET_CONTACT_ACTIVITY_FOLLOW_UP_FAIL,
  payload: error,
})